package de.connect2x.timmy.brandings.lifetimeTheme

import de.connect2x.trixnity.messenger.compose.view.theme.ThemeComponents
import de.connect2x.trixnity.messenger.compose.view.theme.ThemeDarkColorScheme
import de.connect2x.trixnity.messenger.compose.view.theme.ThemeDarkMessengerColors
import de.connect2x.trixnity.messenger.compose.view.theme.ThemeLightColorScheme
import de.connect2x.trixnity.messenger.compose.view.theme.ThemeLightMessengerColors
import de.connect2x.trixnity.messenger.compose.view.theme.ThemeTypography
import org.koin.dsl.module

fun timmyThemeModuleLifetime() = module {
    single<ThemeLightColorScheme> {
        ThemeLightColorSchemeWcImpl
    }

    single<ThemeLightMessengerColors> {
        ThemeLightMessengerColorsWcImpl
    }

    single<ThemeDarkColorScheme> {
        ThemeDarkColorSchemeWcImpl
    }

    single<ThemeDarkMessengerColors> {
        ThemeDarkMessengerColorsWcImpl
    }

    single<ThemeTypography> { ThemeTypographyLifetimeImpl() }

    single<ThemeComponents> { ThemeComponentsLifetimeImpl() }
}
